import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../redux";
import { LanguageContext } from "../../../../../utilities/LocalizationModule";
import { expanderConstants } from "../../../redux/models/constants/expanders";
import ExpanderWithSubtitle from "../ExpanderWithSubtitle";
import { getPinnedItems } from "../../../redux/modules/pinnedItems";
import HomeItem from "./HomeItem";
import { ModeEnum } from "../../enums/modeEnum";
import { IStoreItem } from "../../../interfaces/IStoredItem";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { Spinner } from "@fluentui/react/lib/Spinner";
import { ExpanderStateEnum } from "../../enums/expanderStateEnum";
import { IDialogContentProps } from "@fluentui/react";
import generalModule from "../../../../../utilities/GeneralModule";
import { Pin24Regular } from "../../_v2/components/SvgIcons/Pin24Regular";

const mapDispatchToProps = {
  getPinnedItems
};

const mapStateToProps = (state: RootState) => {
  return {
    pinned: state.pinned,
    accountId: state.user?.account?.accountId,
    showPinned: state.user.settings.showPinned,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface PinnedItemsProps extends PropsFromRedux {
  mode: ModeEnum;
  openFileOptions: (item: IStoreItem, isRecentList: boolean) => void;
  openFolderOptions: (item: IStoreItem, isRecentList: boolean) => void;
  showLicenseDialog: () => void;
  saveToOneDrive: (
    folderName: string,
    fromLocationItemCurrentDirectory?: IPageSettings,
    savingLocationDirectory?: string,
    locationBeforeSaving?: IPageSettings[]
  ) => Promise<void>;
  setLicenseMessageContent: (content: IDialogContentProps) => void;
}

const PinnedItems: React.FunctionComponent<PinnedItemsProps> = ({
  pinned,
  mode,
  openFileOptions,
  openFolderOptions,
  showLicenseDialog,
  saveToOneDrive,
  accountId,
  getPinnedItems,
  showPinned,
  setLicenseMessageContent
}: PinnedItemsProps) => {
  const languageStrings = React.useContext(LanguageContext);
  const [expanderState, setExpanderState] = React.useState<ExpanderStateEnum>(ExpanderStateEnum.unset);

  const canToggle: boolean = generalModule.isInConentMangerMode() ? false : true;

  React.useEffect(() => {
    if (canToggle && showPinned && pinned.pinnedItems === null) {
      (async () => {
        const pinnedCount = await getPinnedItems(accountId);
        if (pinnedCount > 0) {
          setExpanderState(ExpanderStateEnum.expanded);
        }
      })();
    }
  }, [showPinned, canToggle]);

  const items: JSX.Element[] = canToggle && pinned.pinnedItems && pinned.pinnedItems
    .filter(item => !item?.isList)
    .map((item, index) => {
      return (
        <HomeItem
          key={index}
          homeItem={item}
          mode={mode}
          isRecentList={false}
          openFileOptions={openFileOptions}
          openFolderOptions={openFolderOptions}
          showLicenseDialog={showLicenseDialog}
          saveToOneDrive={saveToOneDrive}
          setLicenseMessageContent={setLicenseMessageContent}
        />
      );
    });

  return (
    <ExpanderWithSubtitle
      // iconName="Pinned"
      iconElement={<Pin24Regular />}
      items={!canToggle ? [] : items?.length > 0 ? items : pinned.isPinnedItemsLoading ? [<Spinner key={0} />] : [<p className="xb-empty-location-message centerText" key="0">{languageStrings.PinnedItemsShownHere}</p>]}
      title={languageStrings.Pinned}
      expanderNameToToggle={expanderConstants.home.pinned}
      hasShowMoreButton={true}
      expanderState={expanderState}
      canToggle={canToggle}
    />
  );
};

export default connector(PinnedItems);
